<template>
    <div class="quiz__campaign-page" :class="{ 'quiz__campaign-page-active': quiz_active }">
        <div class="" v-for="(question, key) in questionsToUse">
            <paged-question v-if="question.style.component == 'question'" :key="'question_'+question.id" :index="key" :question="question" :questionsinpage="questionsToUse.length" :question_number="question_number"></paged-question>
            <range v-if="question.style.component == 'range'" :quizactive="quiz_active" :key="'question_'+question.id" :index="key" :question="question" :questionsinpage="questionsToUse.length" :question_number="question_number"></range>
        </div>
        <a v-if="page_completed" href="#" @click.prevent="finishPage" class="quiz__campaign-next quiz__campaign-button" :class="{ 'quiz__campaign-next-active': page_completed }">Next</a>
    </div>
</template>
<script>
import LoadingScreen from './loading-screen';
import PagedQuestion from './paged-question';
import Range from './range';

export default {
    props: [
        'questions'
    ],
    components: {
        PagedQuestion,
        Range,
        LoadingScreen
    },
    created () {
        let vm = this;
        Event.$on('start_quiz', ($event) => { this.quiz_active = true; });
        Event.$on('page_answer_given', ($event) => {
            let count = 0;
            let questions = [];

            vm.question_type = $event.question_type;
            vm.answered[$event.question_id] = ($event.answer_id !== undefined) ? $event.answer_id : false;
            vm.answered.forEach(function(value, item, array){
                if(value!==undefined){
                    count = count + 1;
                    questions[item] = [value];
                }
            });
            if( count === vm.answers_to_give ){
                vm.next_step = vm.answered[vm.last_question];
                $.ajax( '/quiz-campaign/next-grouped/'+ vm.last_question + '/' + vm.answered[vm.last_question] , {
                    method : 'GET',
                    success: function(response, textStatus, xhr) {
                        vm.next_questions = response;
                        vm.page_completed = true;

                        let topOfQuiz = $('#quiz-campaign').offset().top;
                        let heightOfQuiz = $('#quiz-campaign').height();
                        let windowHeight = $(window).height();
                        let yPoint = ((topOfQuiz + heightOfQuiz) - windowHeight);
                        if( yPoint < 0 ){
                            yPoint = 0;
                        }
                        console.log( topOfQuiz, heightOfQuiz, windowHeight, yPoint);
                        $("html, body").animate({ scrollTop: yPoint + 30 }, 300);

                    },
                    error: function(xhr, textStatus, string) {
                        console.log(string);
                    }
                });
            } else {
                console.log('not all answered');
            }
        });
        Event.$on('build_endpoint_key', ($event) => {
            vm.endpoint_key = vm.endpoint_key + $event.question_id + '-';
        });
        Event.$on('endpoint_reached', ($event) => {
            vm.quiz_active = false;
        });
        Event.$on('build_answers_given',($event) => {
            vm.endpoint_dynamic_title[$event.question_id] = $event.answer_content;
        });
    },
    mounted() {
        let vm = this;
        this.last_question = this.questions.length > 0 ? this.questions[this.questions.length-1].id : null;
        Event.$on('trigger_loading', ($event) => {
            vm.quiz_active = false;
        });
    },
    methods: {
        resetPage(){
            let vm = this;
            vm.page_completed = false,
            vm.answered = [],
            vm.next_questions = [],
            vm.next_step = null
        },
        finishPage() {
            let vm = this;

            if( vm.question_type == 1 )  vm.responses.journey.push(vm.last_question + '_' + vm.next_step);
            else if( vm.question_type == 2 ) vm.responses.content.push(vm.last_question + '_' + vm.next_step);
            else vm.responses.other.push(vm.last_question + '_' + vm.next_step);

            vm.responses.all.push(vm.last_question + '_' + vm.next_step);

            if( vm.next_questions !== ''){
                vm.question_number = vm.question_number + 1;
                vm.questionsToUse = vm.next_questions[vm.next_step];
                vm.answers_to_give = vm.questionsToUse.length;
                vm.last_question = vm.questionsToUse.length > 0 ? vm.questionsToUse[vm.questionsToUse.length-1].id : null;
                vm.resetPage();
            } else {

                //loader on here
                Event.$emit('trigger_loading');

                vm.endpoint_key = vm.addAnswerToEndpoint();

                $.ajax('/axios/endpoint-by-key/' + vm.endpoint_key, {
                    method: 'GET',
                    success: function(response, textStatus, xhr) {
                        let localStorage = window.localStorage;
                        localStorage.setItem('title', vm.endpoint_dynamic_title.filter(Boolean) );
                        localStorage.setItem('answers', JSON.stringify(vm.responses));

                        window.location = response.endpoint.links.view;
                    },
                    error: function(xhr, textStatus, string) {
                        console.log(string);
                    }
                });
            }
            scroll(0,0);
        },
        addAnswerToEndpoint(){
            let vm = this;
            return vm.endpoint_key.substring(0, (vm.endpoint_key.length - 1)) + '_' + vm.next_step + '-';
        }

    },
    data() {
        return {
            quiz_active: false,
            page_completed: false,
            is_loading: false,
            answers_to_give: this.questions.length,
            answered: [],
            last_question: null,
            next_questions: [],
            question_type: null,
            current_question: null,
            current_answer: null,
            next_step: null,
            questionsToUse: this.questions,
            question_number: 1,
            responses: {
                content: [],
                journey: [],
                other: [],
                all: []
            },
            endpoint_key: '',
            endpoint_dynamic_title: []
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/paged-questions.vue